<template>   
  <h1 class="title">In Your Hands</h1>
  <div class="pos" ref="pos"></div>
  <!-- Top Section -->
  <div class="d1" ref="d1">
    <div ref="d2" class="d2">
      <img ref="img1" v-if="isMobile" class="img1" src="../assets/in-their-hands.jpg" alt="Woman holding a stack of mail in her hands."/>
      <div class="d2a">
        <div class="d2a1">"Your business, right to their hands"</div>
        <div class="d2a2">No clicks. No clutter. Just customers.</div>
      </div>      
      <div v-if="!isMobile" style="height: 100px"></div>
      <div v-if="isMobile" style="height: 50px"></div>
      <div class="d2b">
        <div class="d2b1">
          <div ref="d2b1a" class="d2b1a">Cost-Effective</div>
          <div style="width: 40px"></div>
          <div class="d2b1b">High-Impact</div>
        </div>
        <div ref="d2b2" class="d2b2">Direct Mail Advertising</div>       
        <div ref="d2b3" class="d2b3" @click="learnMoreScroll">Learn More</div>
      </div>
    </div>        
    <img ref="img1" v-if="!isMobile" class="img1" src="../assets/in-their-hands.jpg" alt="Woman holding a stack of mail in her hands."/>
  </div>
  <!-- Middle -->
  <div ref="d3" class="d3">
    <div class="d3a">
      <div class="d3a1">Ads are skipped. Emails get lost. Ever try ignoring a colorful 9"x12" postcard?</div>
      <div class="d3a2">Exactly!</div>
      <img src="../assets/ad.jpg" alt="Fridge with a 9x12inch coupon card displayed on it." class="img2" />
    </div>
    <div class="d3b">
      <h2 class="d3b1">Why It Works</h2>
      <ul class="d3b2">
        <li><span style="font-weight: bold;">Unskippable:</span> Ads are skipped. Emails get lost. Our 9"x12" postcards demand attention.</li>
        <li><span style="font-weight: bold;">Longer Lifespan:</span> The average digital ad lasts <span class="d3b2a">17 seconds</span>. Our postcards stay in homes for <span class="d3b2a">17 days</span>.</li>
        <li><span style="font-weight: bold;">Cost-Effective:</span> Reach from 10,000 to 35,000 homes for around $0.05 per household by sharing the cost with other businesses.</li>
        <li><span style="font-weight: bold;">Double Exposure:</span> Your ad goes in the mail and on our website. Missed the mailer? They'll find you online.</li>
        <li><span style="font-weight: bold;">Trackable Results:</span> QR codes make it easy to offer coupons and track responses.</li>
      </ul>
    </div>
  </div>
  <!-- Bottom -->
  <div class="d4">
    <div class="d4a">
      <h2 class="d4a1">Why Choose Us?🔥</h2>
      <ul class="d4a2">
        <li>✅ <span style="font-weight:bold;">Highly Effective:</span> Direct mail is one of the most impactful forms of advertising.</li>
        <li>✅ <span style="font-weight: bold;">Cost-Effective:</span> We offer this powerful service at a fraction of the cost of traditional direct mail campaigns <span style="font-weight: bold">(approximately $0.05 per household)</span> by sharing the cost among businesses.</li>
        <li>✅ <span style="font-weight: bold;">Flexible Options:</span> Advertise on a single postcard or multiple mailings to reach your target audience - multi-slot discount available.</li>
        <li>✅ <span style="font-weight: bold;">Dual Impact:</span> Combine the power of physical mail with digital connectivity through QR codes, which can also aid ROI tracking.</li>
      </ul>
      <img v-if="!isMobile" src="../assets/mailer.png" class="img3" alt="9x12 mailer divided into 8 sections for coupons." />
      <img v-if="isMobile" src="../assets/pig.jpg" class="img4" alt="Piggy bank with the word 'Frugal' on it."/>
    </div>
    <div class="d4b">
      <img v-if="!isMobile" src="../assets/pig.jpg" class="img4" alt="Piggy bank with the word 'Frugal' on it."/>
      <div class="d4b1">
        <div class="d4b1a">How It Works!</div>
        <div class="d4b1b">
          Each postcard measures 9″ x 12″ and features 16 advertising spaces (8 on each side). Each space measures 3″ x 4″, giving your business ample room to showcase your message.
          <br><br>
          You can purchase as many spaces as you need, and we'll handle the ad placement, printing, and mailing to ensure your ad reaches thousands of potential customers.
        </div>
      </div>
    </div>
  </div>
</template>


<script>


export default {
  name: 'home',
  data() {
    return {
      d2b1a: 0,
      d2b2: 0,
      d2b3: 0,
      d3h:'616px',
      minw: 0,
      isMobile: false,
    }
  },
  mounted() {            
    this.windowSize();
    window.addEventListener('resize', this.windowSize);

    this.updateViewport();    
    window.addEventListener('resize', this.updateViewport); 
        
    
    if(!this.isMobile){ 
      this.d2b1a = '-' + Math.round(window.screen.height*.9) + 'px';    
      this.d2b2 = '-' + Math.round(window.screen.height*.9) + 'px';  
      this.d2b3 = '-' + Math.round(window.screen.width*.5) + 'px';    
    } else {
      this.d2b1a = '-' + Math.round(window.screen.height) + 'px';    
      this.d2b2 = '-' + Math.round(window.screen.height) + 'px';  
      this.d2b3 = '-' + Math.round(window.screen.width*.9) + 'px';
    }
  },  
  beforeUnmount() {
    window.removeEventListener('resize', this.updateViewport);
    window.removeEventListener('resize', this.windowSize);
  },
  methods: {
    updateViewport() {
      this.minw = window.screen.width*.75 + 'px';      
      let d2 =  this.$refs.d2.getBoundingClientRect();    
      this.d3h = d2.height + 150 + 'px';                       
    },
    learnMoreScroll() {
      this.$refs.d3.scrollIntoView({behavior: 'smooth'});
    },
    windowSize () {
      if (window.innerWidth <= 900) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
  }
}
</script>

<style scoped>
h2 {
  margin: 0;
  padding: 0;
}
  .d1 {        
    width: 100%;
    min-width: v-bind(minw);
    display: flex;
    align-items: center;
    justify-content: space-evenly;   
    min-height: 75vh;
    box-sizing: border-box;
  }
  .d2 {
    /* flex:0; */
    margin-left: 35px;
    margin-right: 35px;
    display: flex;
    flex-direction: column;
    /* min-height: 100%; */
    justify-content: space-evenly;   
    white-space: nowrap; 
  }
  .d2a {
    font-family: 'Arimo Hebrew Subset', sans-serif;
    color: v-bind(colorRed);
    font-size: 26px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

  }
  .d2a2 {
    font-style: italic;
    margin-top:15px;
  }
  .d2b {
    font-family: 'Alata';
    font-style: normal;
    font-weight: 200;
    color: v-bind(colorRed);
    font-size:36px;
    /* width: 100%; */
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .d2b1 {
    display: flex;
    margin-bottom: 10px;
  }
  .d2b1a {
    position: relative;
    animation: d2b1a .75s ease-out forwards;
  }
  .d2b1b {
    position: relative;
    animation: d2b1b 1.5s ease-out forwards;
  }
  .d2b2 {
    margin-bottom: 40px;
    position: relative;
    animation: d2b2 2.25s ease-out forwards;
  }
  .d2b3 {
    background-color: v-bind(colorBlue3);
    color: white;
    border: 1px solid v-bind(colorBlack1);
    padding: 8px;
    border-radius: 10px;
    width:fit-content;
    font-family: 'Alata', sans-serif;
    font-weight: 100px;
    font-style:normal;
    font-size:20px;
    filter: drop-shadow(0 4px 4px rgba(0, 0, 0, .35));
    position: relative;
    animation: d2b3 3s ease-out forwards;
  }
  .d2b3:hover {
    cursor: pointer;
    background-color: v-bind(colorBlue2);
  }
  .d3 {
    background-color: v-bind(colorBlue2);
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    align-items: space-evenly;
  }
  .d3a{
    margin-left: 35px;
    margin-top: 70px;
    text-align: center;
    width: 40%;
    display: flex;
    flex-direction: column;
    /* height: stretch; */
    justify-content: center;
  }
  .d3a1, .d3a2{
    font-family: 'Akatab';
    font-weight: bold;
    font-size: 26px;
    color: white;
    width: 100%;
  }
  .d3a2 {
    color: v-bind(colorBlue4);
    width: 100%;
    text-align: center;
  }
  .d3b{
    margin-right: 35px;
    margin-top: 110px;
    width: 30%;
    margin-left:5%;
    margin-right:5%;
  }
  .d3b1{
    font-family: 'Akatab';
    font-size: 40px;
    color: white;
    text-align: center;
    width: 100%;
    margin-bottom: 50px;
  }
  .d3b2 {
    font-family: 'Akatab';
    font-size: 20px;
    color: white;
    width: 100%;
  }
  .d3b2 > li {
    margin-bottom: 50px;
  }
  .d3b2a {
    color: v-bind(colorBlue4);
  }
  .d4 {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    align-items: space-evenly;
  }
  .d4a {
    margin-left: 35px;
    margin-top: 50px;
    width: 40%;
    display: flex;
    flex-direction: column;
    height: stretch;
    justify-content: center;    
  }
  .d4a1 {
    font-family: 'Akatab';
    font-size: 40px;
    color: v-bind(colorPurple);
    text-align: center;
    margin-bottom: 40px;
  }
  .d4a2 {
    font-family: 'Akatab';
    color: v-bind(colorPurple);
    list-style-type: none;
    margin: 0;
    padding: 0;
    font-size: 20px;
    width: 80%;
    margin-left:10%;
  }
  .d4a2 > li {
    margin-bottom: 50px;
  }
  .d4b {
    margin-right: 35px;
    margin-top: 50px;
    width: 40%; 
    display: flex;
    flex-direction: column;
    /* height: stretch; */
    /* justify-content: space-evenly; */
  }
  .d4b1 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
  .d4b1a {
    font-family: 'Akatab';
    font-size: 40px;
    color: v-bind(colorPurple);
    text-align: center;
    margin-bottom: 40px;
  }
  .d4b1b {
    font-family: 'Akatab';
    color: v-bind(colorPurple);    
    font-size: 20px;
    width: 80%;
    margin-left:10%;
  }
  .img1 {    
    object-fit: contain;
    height: v-bind(d3h);
    border-radius: 10px;    
    display: block; 
  }
  .img2 {
    object-fit: cover;
    border-radius: 10px;
    display: block;
    width: 100%;
    aspect-ratio: 3/2;
    margin-top: 50px;
    margin-bottom: 70px;
  }
  .img3 {
    object-fit: cover;
    border-radius: 10px;
    display: block;
    width: 80%;
    margin-left: 10%;
    margin-top: 50px;
    margin-bottom: 70px;
    border: 15px solid v-bind(colorPurple);
    box-sizing: border-box;
  }
  .img4 {
    object-fit: cover;
    border-radius: 10px;
    display: block;
    width: 80%;
    margin-left: 10%;
    margin-top: 70px;
  }
  .title {
    position:absolute;
    min-width: v-bind(minw);
    top: 85px;
    font-family: 'Patrick Hand SC';
    display: flex;
    justify-content: center;
    width: 100%;
    font-size:96px;
    font-weight: 400;
    font-style: normal;
    /* margin-top:90px; */    
    color: v-bind(colorRed);
    text-shadow:0 4px 4px rgba(0, 0, 0, 0.35);
  }
  @keyframes d2b1a {
    0% {
      transform: translateY(v-bind(d2b1a));
    }
    100% {
      transform: translateY(0);
    }
  }
  @keyframes d2b1b {
    0% {
      transform: translateY(v-bind(d2b1a));
    }
    50% {
      transform: translateY(v-bind(d2b1a));
    }
    100% {
      transform: translateY(0);
    }
  }
  @keyframes d2b2 {
    0% {
      transform: translateY(v-bind(d2b2));
    }
    66% {
      transform: translateY(v-bind(d2b2));
    }
    100% {
      transform: translateY(0);
    }
  }
  @keyframes d2b3 {
    0% {
      transform: translateX(v-bind(d2b3));
    }
    75% {
      transform: translateX(v-bind(d2b3));
    }
    100% {
      transform: translateY(0);
    }
  }

@media only screen and (max-width: 900px) {
  ul {
    box-sizing: border-box;
  }
  .d1 {
    flex-direction: column;
  }
  .d2 {
    margin: 0;
    margin-top: 35px;
  }
  .d2a {
    font-size: 17px;
  }
  .d2b {
    font-size: 22px;
    margin-bottom: 50px;
  }
  .d2b2 {
    margin-bottom: 20px;
  }
  .d3 {
    flex-direction: column;
  }
  .d3a {
    width: 90%;
    margin: 0;
    margin-left:5%;
    margin-top: 50px;
  }
  .d3b {
    width: 90%;
    margin: 0;
    padding: 0;
    margin-left: 5%;
    
  }
  .d3b1 {
    margin-bottom: 25px;
  }
  .d4 {
    flex-direction: column;
  }
  .d4a, .d4b {
    width: 90%;
    margin: 0;
    margin-left: 5%;
  }
  .d4a1 {
    margin-top: 50px;
  }
  .d4a2 {
    width: 94%;
    margin-left: 3%;
  }
  .d4b1a {
    margin-bottom: 18px;
  }
  .d4b1b {
    width: 100%;
    margin: 0;
    margin-bottom: 50px;
  }
  .img1 {
    height: auto;
    width: calc(100% - 70px);
    margin-left: 35px;
    margin-right: 35px;
    margin-bottom: 35px;
    box-sizing: border-box;
  }
  .img2 {
    margin-bottom: 50px;
  }
  .img4 {
    margin-top: 0;
    margin-bottom: 50px;
  }
  .title {
    font-size: 50px;
    top: 130px;
  }
}
</style>